import { createSelector } from '@ngrx/store';
import { conversationsQuery } from '@cigna/omni/conversations-state-data-access';
import { generateSummaryListItem } from '@cigna/omni/conversation-summary-list-feature';

export const selectRecentActiveOrUnreadConversationSummaryListItem =
  createSelector(
    conversationsQuery.selectRecentActiveOrUnreadConversation,
    (item) => (item ? generateSummaryListItem(item) : null),
  );
